import React from 'react';

interface StepGuidanceProps {
  children: React.ReactNode;
}

/** Remediation shown only while a checklist step is failing. */
const StepGuidance: React.FC<StepGuidanceProps> = ({ children }) => (
  <div className="step-guidance">
    <span className="step-guidance-label">What to do</span>
    <div className="step-guidance-body">{children}</div>
  </div>
);

export default StepGuidance;
